namespace SPA
{
	export namespace Realtor
	{
		enum FormState
		{
			NULL,
			NEW,
			OLD
		}

		export class RealtorObjectCreator
			extends ui.tab.TabHTMLPresentation
		{

			private	m_Company:				Wollmilch.CompanyObject;
			private	m_FormState:			FormState;
			private	m_Form:						ui.Form.Form;
			private	m_ObjectData:			ui.Box.Box;
			private	m_CustomerData:		ui.Box.Box;
			private	m_CustomerType:		ui.Form.RadioGroup;
			private	m_CustomerInputs:	Array<ui.Form.BasicInputField<HTMLElement>>;
			private	m_CustomerList:		any[];
			private	m_ObjectAddress:	Array<ui.Form.BasicInputField<HTMLElement>>;
			private	m_ObjectOwner:		Array<ui.Form.BasicInputField<HTMLElement>>;
			private	m_ObjectDatas:		Array<ui.Form.BasicInputField<HTMLElement>>;

			public constructor( company: Wollmilch.CompanyObject, object_type: 'Disposal'|'Let' )
			{
				super();

				this.m_FormState			= FormState.NULL;
				this.m_CustomerList		= [];

				this.Initialize(
					{
						aria:
						{
							label: app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.new_realtor_form' )
						}
					}
				);

				this.m_Company				= company;
				this.m_CustomerInputs	= [];
				this.m_ObjectData			= new ui.Box.Box();
				this.m_CustomerData		= new ui.Box.Box();
				this.m_FormState			= FormState.NULL;
				this.m_Form						= new ui.Form.Form(
					{
						classes: [ 'form-horizontal' ],
						method: 'POST',
						action: 'object/new/' + object_type + 'RealtorObject',
						notSwitchable: true,
						submit: ( method: ui.Form.FormMethod, action: string, parameter: ui.Form.IFormParameter ) =>
						{
							if ( parameter.customer.type === 'NEW' )
							{
								if ( parameter.customer.contact.phone1.number === '' )
								{
									delete parameter.customer.contact.phone1;
								}

								if ( parameter.customer.contact.phone2.number === '' )
								{
									delete parameter.customer.contact.phone2;
								}
							}

							new Wollmilch.AJAX(
								{
									method,
									url: action,
									data: parameter,
									on:
									{
										success: ( text: string ): void =>
										{
											const obj = Wollmilch.jsonize( text );

											if ( !obj )
											{
												app.addNotify(
													{
														title: [ app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.error_title' ) ],
														body: [ app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.error_body' ) ],
														context: 'danger',
														timeout: Number(app.getConfigValue("ToastTimeout"))
													}
												);

												return;
											}

											const data = obj.data as Wollmilch.Realtor.Object;
											const tc: ui.tab.TabControl = app.getGlobalTabControl();

											tc.addTab(
												data.ObjectNumber,
												new Page( data ),
												true
											);

											if ( this.m_Entry ) { tc.removeTab( this.m_Entry ); }
										}
									}
								},
								Wollmilch.AJAXCallbase_e.REALTOR
							).send();
						},
						invalid: () => app.addNotify(
							{
								title: [ ui.$$.h( 4, app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.error_form_title' ) ) ],
								body: [ ui.$$.p().text( app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.error_form_body' ) ) ],
								context: 'danger',
								timeout: Number(app.getConfigValue("ToastTimeout"))
							}
						)
					}
				)
				.append(
					ui.$$.div().addClass( 'row' )
						.append( ui.$$.div().addClass( 'col-sm-12 col-md-6' ).append( this.m_ObjectData.Root() ) )
						.append( ui.$$.div().addClass( 'col-sm-12 col-md-6' ).append( this.m_CustomerData.Root() ) )
				) as ui.Form.Form;
				this.m_ObjectAddress	= new Array();
				this.m_ObjectOwner		= new Array();
				this.m_ObjectDatas		= new Array();

				this.m_Form.Input( new ui.Form.NumberInput( this.m_Company.ID || 0, { name: 'contractor' } ) );

				this.m_ObjectData.addTitle( app.getMessage( 'Realtor.NEW.TITLE.object-capture' ) );
				this.m_CustomerData.addTitle( app.getMessage( 'Realtor.NEW.TITLE.customer-capture' ) );

				this.append( this.m_Form );

				this.m_CustomerType	=	new ui.Form.RadioGroup(
					{
						name: 'customer.type',
						required: true,
						inline: 2,
						css:
						{
							'text-align': 'center'
						},
						radioButtons:
						[
							{
								value: 'NEW',
								title: app.getMessage( 'Realtor.NEW.TITLE.CUSTOMER-TYPE.NEW' ),
								descriptor:
								{
									on:
									{
										click: () =>
										{
											this.m_FormState = FormState.NEW;
											this.build();
										}
									}
								}
							},
							{
								value: 'OLD',
								title: app.getMessage( 'Realtor.NEW.TITLE.CUSTOMER-TYPE.OLD' ),
								descriptor:
								{
									on:
									{
										click: () =>
										{
											this.m_FormState = FormState.OLD;
											this.build();
										}
									}
								}
							}
						]
					}
				);

				this.m_Form.Initialize();

				this.m_Form.Input( this.m_CustomerType );

				this.build();

				new ui.Box.Box().append(
					ui.$$.div().append(
						ui.$$.div().append(
							ui.$$.div()
								.append( $( this.m_Form.Buttons.submit.getElement() ).text( app.getMessage( 'Aux.SAVE_BTN' ) ) )
								// .append( $( this.m_Form.Buttons.reset.getElement() ).text( app.getMessage( 'Aux.RESET_BTN' ) ) )
								.append( $( this.m_Form.Buttons.cancel.getElement() ).text( app.getMessage( 'Aux.ABORT_BTN' ) ) )
							.addClass( 'col-xs-12' )
						).addClass( 'row' )
					).addClass( 'container-fluid' )
				).appendTo( ui.$$.div().addClass( 'row' ).appendTo( this.m_Form.Root() ) );
			}

			public rebuild( root: JQuery|ui.base.BaseHTMLElement ): RealtorObjectCreator
			{
				super.rebuild( root );

				this.build();

				return this;
			}

			private buildNewCustomerForm(): void
			{
				this.m_CustomerData.append(
					$(
						new Button
						(
							{
								title: app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.copy_from_owner' ),
								style: 'info',
								size: 'sm',
								classes: [ 'pull-right' ],
								on:
								{
									click: () =>
									{
										const findInputByName = ( name: string ): ui.Form.BasicInputField|undefined =>
										{
											return this.m_ObjectOwner.find(
												( input: ui.Form.BasicInputField ) =>
												{
													return input.Name === name;
												}
											);
										};

										this.m_CustomerInputs.forEach(
											(input) =>
											{
												if ( !input.Name ) { return; }

												const prefill = findInputByName(
													input.Name
														.replace( 'customer.address', 'object.owner.address' )
														.replace( 'customer.client', 'object.owner.person' )
												);

												if ( prefill ) { input.value( prefill.val() ); }
											}
										);
									}
								}
							}
						).getElement()
					)
				);

				const addCustomerInput = ( input: ui.Form.BasicInputField, baseclass: string[] ) =>
				{
					this.m_CustomerInputs.push( input );
					this.m_Form.Input( input );

					input.Base().addClass( baseclass.join( ' ' ) );
				};

				this.m_CustomerData.append(
					ui.$$.h( 4, app.getMessage( 'Realtor.NEW.TITLE.object-client-data' ) )
				);
				this.m_CustomerData.append(
					ui.$$.h( 4, app.getMessage( 'Realtor.NEW.TITLE.object-person-data' ) ).addClass( 'text-muted' )
				);

				let fg = ui.$$.div().addClass( 'form-group' ).appendTo( this.m_CustomerData.Root() );

				addCustomerInput(
					new ui.Form.Select(
						{
							blank: app.getMessage( 'Realtor.NEW.TITLE.SELECT.gender' ),
							option:
							{
								m: app.getMessage( 'Realtor.NEW.TITLE.GENDER.MALE.select' ),
								f: app.getMessage( 'Realtor.NEW.TITLE.GENDER.FEMALE.select' ),
							},
							name: 'customer.client.gender',
							required: true
						}
					).rebuild( fg.append( ui.$$.label().text( 'Anrede' + '*' ).addClass( 'control-label col-xs-12 col-md-2' ) ) ),
					[ 'col-xs-12', 'col-md-4' ]
				);

				addCustomerInput(
					new ui.Form.Select(
						{
							option:
							{
								'': '',
								'Dr.': app.getMessage( 'Realtor.NEW.TITLE.SALUTATION.SELECT.dr' ),
								'Prof.': app.getMessage( 'Realtor.NEW.TITLE.SALUTATION.SELECT.prof' ),
								'Prof. Dr.': app.getMessage( 'Realtor.NEW.TITLE.SALUTATION.SELECT.profdr' )
							},
							name: 'customer.client.salutation'
						}
					).rebuild( fg.append( ui.$$.label().text( app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.LABEL.salutation' ) ).addClass( 'control-label col-xs-12 col-md-2' ) ) ),
					[ 'col-xs-12', 'col-md-4' ]
				);

				addCustomerInput(
					new ui.Form.TextInput(
						'',
						{
							name: 'customer.client.name',
							placeholder: app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.LABEL.name' ),
							required: true
						}
					).rebuild( ui.$$.div().addClass( 'form-group' ).append( ui.$$.label().text( app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.LABEL.name' ) + '*' ).addClass( 'control-label col-xs-12 col-md-2' ) ).appendTo( this.m_CustomerData.Root() ) ),
					[ 'col-xs-12', 'col-md-10' ]
				);

				addCustomerInput(
					new ui.Form.TextInput(
						'',
						{
							name: 'customer.client.surname',
							placeholder: app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.LABEL.surname' ),
							required: true
						}
					).rebuild( ui.$$.div().addClass( 'form-group' ).append( ui.$$.label().text( app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.LABEL.surname' ) + '*' ).addClass( 'control-label col-xs-12 col-md-2' ) ).appendTo( this.m_CustomerData.Root() ) ),
					[ 'col-xs-12', 'col-md-10' ]
				);

				addCustomerInput(
					new ui.Form.DateInput(
						new Date(),
						'd.m.Y',
						{
							name: 'customer.client.birthday',
							required: true
						}
					).rebuild( ui.$$.div().addClass( 'form-group' ).append( ui.$$.label().text( app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.LABEL.birthday' ) ).addClass( 'control-label col-xs-12 col-md-2' ) ).appendTo( this.m_CustomerData.Root() ) ),
					[ 'col-xs-12', 'col-md-10' ]
				);

				this.m_CustomerData.append( ui.$$.h( 4, app.getMessage( 'Address.SPECIAL.PostalAddress_Administrative' ) ).addClass( 'text-muted' ) );

				fg = ui.$$.div().addClass( 'form-group' ).append(
					ui.$$.label().text( app.getMessage( 'Address.LABEL.COMB.Str_HNo' ) + '*' ).addClass( 'control-label col-xs-12 col-md-2' )
				).appendTo( this.m_CustomerData.Root() );

				addCustomerInput(
					new ui.Form.TextInput(
						'',
						{
							name: 'customer.address.street',
							required: true,
							placeholder: app.getMessage( 'Address.LABEL.LONG.Street' )
						}
					).rebuild( fg ),
					[ 'col-xs-12', 'col-md-7' ]
				);

				addCustomerInput(
					new ui.Form.TextInput(
						'',
						{
							name: 'customer.address.housenumber',
							required: true,
							placeholder: app.getMessage( 'Address.LABEL.LONG.Housenumber' )
						}
					).rebuild( fg ),
					[ 'col-xs-12', 'col-md-3' ]
				);

				fg = ui.$$.div().addClass( 'form-group' ).append(
					ui.$$.label().text( app.getMessage( 'Address.LABEL.COMB.PC_City' ) + '*' ).addClass( 'control-label col-xs-12 col-md-2' )
				).appendTo( this.m_CustomerData.Root() );

				addCustomerInput(
					new ui.Form.TextInput(
						'',
						{
							name: 'customer.address.postalcode',
							required: true,
							placeholder: app.getMessage( 'Address.LABEL.SHORT.Postalcode' )
						}
					).rebuild( fg ),
					[ 'col-xs-12', 'col-md-3' ]
				);

				addCustomerInput(
					new ui.Form.TextInput(
						'',
						{
							name: 'customer.address.city',
							required: true,
							placeholder: app.getMessage( 'Address.LABEL.LONG.City' )
						}
					).rebuild( fg ),
					[ 'col-xs-12', 'col-md-7' ]
				);

				fg = ui.$$.div().addClass( 'form-group' ).append(
					ui.$$.label().text( app.getMessage( 'Address.LABEL.COMB.State_Country' ) ).addClass( 'control-label col-xs-12 col-md-2' )
				).appendTo( this.m_CustomerData.Root() );

				addCustomerInput(
					new ui.Form.TextInput(
						'',
						{
							name: 'customer.address.state',
							required: false,
							placeholder: app.getMessage( 'Address.LABEL.LONG.State' )
						}
					).rebuild( fg ),
					[ 'col-xs-12', 'col-md-5' ]
				);

				addCustomerInput(
					new ui.Form.TextInput(
						'',
						{
							name: 'customer.address.country',
							required: false,
							placeholder: app.getMessage( 'Address.LABEL.LONG.Country' )
						}
					).rebuild( fg ),
					[ 'col-xs-12', 'col-md-5' ]
				);

				this.m_CustomerData.append( ui.$$.h( 4, 'Kontaktdaten' ).addClass( 'text-muted' ) );

				fg = ui.$$.div().addClass( 'form-group' ).append(
					ui.$$.label().text( app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.phone.title' ) + ' 1' ).addClass( 'control-label col-xs-12 col-md-2' )
				).appendTo( this.m_CustomerData.Root() );

				addCustomerInput(
					new ui.Form.TelInput(
						'',
						{
							name: 'customer.contact.phone1.number',
							required: false,
							placeholder: app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.phone.title' )
						}
					).rebuild( fg ),
					[ 'col-xs-12 col-md-10' ]
				);

				addCustomerInput(
					new ui.Form.Select(
						{
							name: 'customer.contact.phone1.type',
							required: false,
							blank: app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.phone.selection' ),
							option:
							{
								home: app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.phone.home' ),
								mobile: app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.phone.mobile' ),
								office: app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.phone.office' )
							}
						}
					).rebuild( fg ),
					[ 'col-xs-12 col-md-10 col-md-offset-2' ]
				);

				addCustomerInput(
					new ui.Form.Select(
						{
							name: 'customer.contact.phone1.reachability',
							required: false,
							blank: app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.phone.reachability' ),
							option:
							{
								morning: app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.phone.morning' ),
								evening: app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.phone.evening' ),
								fullday: app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.phone.fullday' )
							}
						}
					).rebuild( fg ),
					[ 'col-xs-12 col-md-10 col-md-offset-2' ]
				);

				fg = ui.$$.div().addClass( 'form-group' ).append(
					ui.$$.label().text( app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.phone.title' ) + ' 2' ).addClass( 'control-label col-xs-12 col-md-2' )
				).appendTo( this.m_CustomerData.Root() );

				addCustomerInput(
					new ui.Form.TelInput(
						'',
						{
							name: 'customer.contact.phone2.number',
							required: false,
							placeholder: app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.phone.title' )
						}
					).rebuild( fg ),
					[ 'col-xs-12 col-md-10' ]
				);

				addCustomerInput(
					new ui.Form.Select(
						{
							name: 'customer.contact.phone2.type',
							required: false,
							blank: app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.phone.selection' ),
							option:
							{
								home: app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.phone.home' ),
								mobile: app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.phone.mobile' ),
								office: app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.phone.office' )
							}
						}
					).rebuild( fg ),
					[ 'col-xs-12 col-md-10 col-md-offset-2' ]
				);

				addCustomerInput(
					new ui.Form.Select(
						{
							name: 'customer.contact.phone2.reachability',
							required: false,
							blank: app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.phone.reachability' ),
							option:
							{
								morning: app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.phone.morning' ),
								evening: app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.phone.evening' ),
								fullday: app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.phone.fullday' )
							}
						}
					).rebuild( fg ),
					[ 'col-xs-12 col-md-10 col-md-offset-2' ]
				);

				fg = ui.$$.div().addClass( 'form-group' ).append( ui.$$.label().text( app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.email_title' ) + '*' ).addClass( 'control-label col-xs-12 col-md-2' ) ).appendTo( this.m_CustomerData.Root() );

				addCustomerInput(
					new ui.Form.EmailInput(
						'',
						{
							name: 'customer.contact.email',
							required: true,
							placeholder: app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.email_address' )
						}
					).rebuild( fg ),
					[ 'col-xs-12 col-md-10' ]
				);
			}

			private buildOldCustomerForm(): void
			{
				const inputs: {[key: string]: ui.Form.BasicInputField} = {};

				const staticForm: ui.Form.Form = new ui.Form.Form(
					{
						classes: [ 'form-horizontal' ],
						method: 'POST',
						action: 'object/new/DisposalRealtorObject',
						submit: () => {},
						static: true,
						notSwitchable: true
					}
				).appendTo( this.m_CustomerData ) as ui.Form.Form;
				staticForm.Initialize();

				const addCustomerInput = ( input: ui.Form.BasicInputField, baseclass: string[] ): ui.Form.BasicInputField => { this.m_CustomerInputs.push( input ); staticForm.Input( input ); input.Base().addClass( baseclass.join( ' ' ) ); return input; };

				this.m_CustomerData.append( ui.$$.h( 4, app.getMessage( 'Realtor.NEW.TITLE.object-client-data-search' ) ) );

				const search: ui.Form.InputTypeahead = new ui.Form.InputTypeahead(
					{
						displayText: ( item: Wollmilch.ClientObject ): string =>
						{
							let address: string = "";

							item.Address.forEach( (adr) =>
								{
									if ( adr.KindOf === 'domicile' && adr.AddressType === 'PostalAddress' )
									{
										address = ', ' + adr.display;
									}
								}
							);

							return item.Surname + " " + item.Name + address;
						},
						afterSelect: ( item: Wollmilch.ClientObject ) =>
						{
							staticForm.reset();

							inputs[ 'customer.client.gender' ].value( item.Gender );
							inputs[ 'customer.client.salutation' ].value( item.Title );
							inputs[ 'customer.client.name' ].value( item.Name );
							inputs[ 'customer.client.surname' ].value( item.Surname );
							inputs[ 'customer.client.birthday' ].value( new Date(item.Birthday || new Date() ).pattern('d.m.Y') );
							inputs[ 'customer.client.id' ].value( item.ID || 0 );

							item.Address.forEach( (adr) =>
								{
									if ( adr.KindOf === 'domicile' && adr.AddressType === 'PostalAddress' )
									{
										const addr: Wollmilch.PostalAddressObject = adr as Wollmilch.PostalAddressObject;

										inputs[ 'customer.address.street' ].value( addr.Street );
										inputs[ 'customer.address.housenumber' ].value( addr.HouseNumber );
										inputs[ 'customer.address.postalcode' ].value( addr.PostalCode );
										inputs[ 'customer.address.city' ].value( addr.City );
										inputs[ 'customer.address.state' ].value( addr.State );
										inputs[ 'customer.address.country' ].value( addr.Country );
									}
								}
							);
						}
					}
				).rebuild( ui.$$.div().addClass( 'form-group' ).appendTo( this.m_CustomerData.Root() ) ).addClass( 'col-xs-12' ) as ui.Form.InputTypeahead;
				this.m_CustomerData.append( ui.$$.p().append( app.getMessage( 'Realtor.NEW.TITLE.CUSTOMER.old-customer-help-text' ) ).addClass( 'help-block' ) );

				this.m_CustomerData.append( ui.$$.h( 4, app.getMessage( 'Realtor.NEW.TITLE.object-person-data' ) ).addClass( 'text-muted' ) );

				let fg = ui.$$.div().addClass( 'form-group' ).appendTo( this.m_CustomerData.Root() );

				inputs[ 'customer.client.id' ] = new ui.Form.HiddenNumberInput( -1, 'customer.id' ).rebuild( fg );
				this.m_Form.Input( inputs[ 'customer.client.id' ] );

				inputs[ 'customer.client.gender' ] = addCustomerInput(
					new ui.Form.Select(
						{
							blank: app.getMessage( 'Realtor.NEW.TITLE.SELECT.gender' ),
							option:
							{
								m: app.getMessage( 'Realtor.NEW.TITLE.GENDER.MALE.select' ),
								f: app.getMessage( 'Realtor.NEW.TITLE.GENDER.FEMALE.select' )
							},
							name: 'customer.client.gender',
							required: true
						}
					).rebuild( fg.append( ui.$$.label().text( 'Anrede' ).addClass( 'control-label col-xs-12 col-md-2' ) ) ),
					[ 'col-xs-12', 'col-md-4' ]
				);

				this.m_CustomerInputs.push( inputs[ 'customer.id' ] );
				this.m_Form.Input( inputs[ 'customer.id' ] );

				inputs[ 'customer.client.salutation' ] = addCustomerInput(
					new ui.Form.Select(
						{
							option:
							{
								'': '',
								'Dr.': app.getMessage( 'Realtor.NEW.TITLE.SALUTATION.SELECT.dr' ),
								'Prof.': app.getMessage( 'Realtor.NEW.TITLE.SALUTATION.SELECT.prof' ),
								'Prof. Dr.': app.getMessage( 'Realtor.NEW.TITLE.SALUTATION.SELECT.profdr' )
							},
							name: 'customer.client.salutation'
						}
					).rebuild( fg.append( ui.$$.label().text( app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.LABEL.salutation' ) ).addClass( 'control-label col-xs-12 col-md-2' ) ) ),
					[ 'col-xs-12', 'col-md-4' ]
				);

				inputs[ 'customer.client.name' ] = addCustomerInput(
					new ui.Form.TextInput(
						'',
						{
							name: 'customer.client.name',
							placeholder: app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.LABEL.name' ),
							required: true
						}
					).rebuild( ui.$$.div().addClass( 'form-group' ).append( ui.$$.label().text( app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.LABEL.name' ) ).addClass( 'control-label col-xs-12 col-md-2' ) ).appendTo( this.m_CustomerData.Root() ) ),
					[ 'col-xs-12', 'col-md-10' ]
				);

				inputs[ 'customer.client.surname' ] = addCustomerInput(
					new ui.Form.TextInput(
						'',
						{
							name: 'customer.client.surname',
							placeholder: app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.LABEL.surname' ),
							required: true
						}
					).rebuild( ui.$$.div().addClass( 'form-group' ).append( ui.$$.label().text( app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.LABEL.surname' ) ).addClass( 'control-label col-xs-12 col-md-2' ) ).appendTo( this.m_CustomerData.Root() ) ),
					[ 'col-xs-12', 'col-md-10' ]
				);

				inputs[ 'customer.client.birthday' ] = addCustomerInput(
					new ui.Form.DateInput(
						new Date(),
						'd.m.Y',
						{
							name: 'customer.client.birthday',
							required: true
						}
					).rebuild( ui.$$.div().addClass( 'form-group' ).append( ui.$$.label().text( app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.LABEL.birthday' ) ).addClass( 'control-label col-xs-12 col-md-2' ) ).appendTo( this.m_CustomerData.Root() ) ),
					[ 'col-xs-12', 'col-md-10' ]
				);

				this.m_CustomerData.append( ui.$$.h( 4, app.getMessage( 'Address.SPECIAL.PostalAddress_Administrative' ) ).addClass( 'text-muted' ) );

				fg = ui.$$.div().addClass( 'form-group' ).append(
					ui.$$.label().text( app.getMessage( 'Address.LABEL.COMB.Str_HNo' ) ).addClass( 'control-label col-xs-12 col-md-2' )
				).appendTo( this.m_CustomerData.Root() );

				inputs[ 'customer.address.street' ] = addCustomerInput(
					new ui.Form.TextInput(
						'',
						{
							name: 'customer.address.street',
							required: true,
							placeholder: app.getMessage( 'Address.LABEL.LONG.Street' )
						}
					).rebuild( fg ),
					[ 'col-xs-12', 'col-md-7' ]
				);

				inputs[ 'customer.address.housenumber' ] = addCustomerInput(
					new ui.Form.TextInput(
						'',
						{
							name: 'customer.address.housenumber',
							required: true,
							placeholder: app.getMessage( 'Address.LABEL.LONG.Housenumber' )
						}
					).rebuild( fg ),
					[ 'col-xs-12', 'col-md-3' ]
				);

				fg = ui.$$.div().addClass( 'form-group' ).append(
					ui.$$.label().text( app.getMessage( 'Address.LABEL.COMB.PC_City' ) ).addClass( 'control-label col-xs-12 col-md-2' )
				).appendTo( this.m_CustomerData.Root() );

				inputs[ 'customer.address.postalcode' ] = addCustomerInput(
					new ui.Form.TextInput(
						'',
						{
							name: 'customer.address.postalcode',
							required: true,
							placeholder: app.getMessage( 'Address.LABEL.SHORT.Postalcode' )
						}
					).rebuild( fg ),
					[ 'col-xs-12', 'col-md-3' ]
				);

				inputs[ 'customer.address.city' ] = addCustomerInput(
					new ui.Form.TextInput(
						'',
						{
							name: 'customer.address.city',
							required: true,
							placeholder: app.getMessage( 'Address.LABEL.LONG.City' )
						}
					).rebuild( fg ),
					[ 'col-xs-12', 'col-md-7' ]
				);

				fg = ui.$$.div().addClass( 'form-group' ).append(
					ui.$$.label().text( app.getMessage( 'Address.LABEL.COMB.State_Country' ) ).addClass( 'control-label col-xs-12 col-md-2' )
				).appendTo( this.m_CustomerData.Root() );

				inputs[ 'customer.address.state' ] = addCustomerInput(
					new ui.Form.TextInput(
						'',
						{
							name: 'customer.address.state',
							required: false,
							placeholder: app.getMessage( 'Address.LABEL.LONG.State' )
						}
					).rebuild( fg ),
					[ 'col-xs-12', 'col-md-5' ]
				);

				inputs[ 'customer.address.country' ] = addCustomerInput(
					new ui.Form.TextInput(
						'',
						{
							name: 'customer.address.country',
							required: false,
							placeholder: app.getMessage( 'Address.LABEL.LONG.Country' )
						}
					).rebuild( fg ),
					[ 'col-xs-12', 'col-md-5' ]
				);

				new Wollmilch.AJAX(
					{
						url: 'customer/list/' + this.m_Company.ID + '/limit/10000000/page/0',
						method: 'GET',
						on:
						{
							success: ( text: string ): void =>
							{
								const obj = Wollmilch.jsonize( text );

								if ( !obj ) { return; }

								this.m_CustomerList = new Array();

								obj.data.forEach( ( element: any ) => { this.m_CustomerList.push( element.Customer ); } );

								search.Source( this.m_CustomerList );
							}
						}
					}
				).send();
			}

			private buildObjectForm(): void
			{
				this.m_ObjectData.append(
					ui.$$.p().addClass( 'form-required text-danger small-caps' ).text(
						app.getMessage( 'Aux.REQUIRED_INPUTS' )
					)
				);

				if ( this.m_ObjectAddress.length === 0 )
				{
					this.m_ObjectAddress.push(
						new ui.Form.TextInput(
							'',
							{
								name: 'object.address.street',
								required: true,
								placeholder: app.getMessage( 'Address.LABEL.LONG.Street' )
							}
						)
					);

					this.m_ObjectAddress.push(
						new ui.Form.TextInput(
							'',
							{
								name: 'object.address.housenumber',
								required: true,
								placeholder: app.getMessage( 'Address.LABEL.LONG.Housenumber' )
							}
						)
					);

					this.m_ObjectAddress.push(
						new ui.Form.TextInput(
							'',
							{
								name: 'object.address.postalcode',
								required: true,
								placeholder: app.getMessage( 'Address.LABEL.SHORT.Postalcode' )
							}
						)
					);

					this.m_ObjectAddress.push(
						new ui.Form.TextInput(
							'',
							{
								name: 'object.address.city',
								required: true,
								placeholder: app.getMessage( 'Address.LABEL.LONG.City' )
							}
						)
					);

					this.m_ObjectAddress.push(
						new ui.Form.TextInput(
							'',
							{
								name: 'object.address.state',
								required: false,
								placeholder: app.getMessage( 'Address.LABEL.LONG.State' )
							}
						)
					);

					this.m_ObjectAddress.push(
						new ui.Form.TextInput(
							'',
							{
								name: 'object.address.country',
								required: false,
								placeholder: app.getMessage( 'Address.LABEL.LONG.Country' )
							}
						)
					);
				}

				if ( this.m_ObjectDatas.length == 0 )
				{
					this.m_ObjectDatas.push(
						new ui.Form.RadioGroup(
							{
								name: 'object.data.building-type',
								required: true,
								inline: 4,
								radioButtons:
								[
									{
										value: 'FamilyHouse',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.General.BuildingKind.FamilyHouse' )
									},
									{
										value: 'SemiHouse',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.General.BuildingKind.SemiHouse' )
									},
									{
										value: 'MiddleHouse',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.General.BuildingKind.MiddleHouse' )
									},
									{
										value: 'EndHouse',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.General.BuildingKind.EndHouse' )
									},
									{
										value: 'LivingAndBusinessHouse',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.General.BuildingKind.LivingAndBusinessHouse' ),
										descriptor:
										{
											disabled: true
										}
									},
									{
										value: 'ApartmentHouse',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.General.BuildingKind.ApartmentHouse' )
									},
									{
										value: 'Apartment',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.General.BuildingKind.Apartment' ),
										descriptor:
										{
											disabled: true
										}
									}
								]
							}
						)
					);

					this.m_ObjectDatas.push(
						new ui.Form.Checkbox(
							{
								title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.General.BuildingKind.ApartmentAvailable' ),
								descriptor:
								{
									name: 'object.data.ELW',
								}
							},
							true
						)
					);

					this.m_ObjectDatas.push(
						new ui.Form.TextInput(
							'',
							{
								placeholder: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.General.BuildYear' ),
								required: true,
								name: 'object.data.construction-year'
							}
						)
					);

					this.m_ObjectDatas.push(
						new ui.Form.RadioGroup(
							{
								name: 'object.data.construction-status',
								required: true,
								inline: 3,
								radioButtons:
								[
									{
										value: 'underConstruction',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.UNIT.General.ConstructionRate.underConstruction' )
									},
									{
										value: 'Renovation',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.UNIT.General.ConstructionRate.Renovation' )
									},
									{
										value: 'finished',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.UNIT.General.ConstructionRate.finished' )
									}
								]
							}
						)
					);

					this.m_ObjectDatas.push(
						new ui.Form.CheckboxGroup(
							{
								name: 'object.data.occupation-status',
								inline: 3,
								checkboxes:
								[
									{
										name: 'self-occupation',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.Applicability.Occupation.self' ),
										descriptor:
										{
											name: 'self-occupation'
										}
									},
									{
										name: 'foreign-occupation',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.Applicability.Occupation.foreign' ),
										descriptor:
										{
											name: 'foreign-occupation'
										}
									}
								]
							}
						)
					);

					this.m_ObjectDatas.push(
						new ui.Form.RadioGroup(
							{
								name: 'object.data.TenancyRate',
								required: true,
								inline: 3,
								radioButtons:
								[
									{
										value: 'full',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.General.TenancyRate.full' )
									},
									{
										value: 'empty',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.General.TenancyRate.empty' )
									},
									{
										value: 'halffull',
										title: app.getMessage( 'Realtor.OBJECT.INPUT.BUILDING.General.TenancyRate.halffull' )
									}
								]
							}
						)
					);

					this.m_ObjectDatas.push(
						new ui.Form.TextArea(
							{
								name: 'object.data.notes',
								rows: 5,
								css:
								{
									resize: 'vertical'
								}
							}
						)
					);
				}

				if ( this.m_ObjectOwner.length == 0 )
				{
					this.m_ObjectOwner.push(
						new ui.Form.TextInput(
							'',
							{
								name: 'object.owner.address.street',
								required: true,
								placeholder: app.getMessage( 'Address.LABEL.LONG.Street' )
							}
						)
					);

					this.m_ObjectOwner.push(
						new ui.Form.TextInput(
							'',
							{
								name: 'object.owner.address.housenumber',
								required: true,
								placeholder: app.getMessage( 'Address.LABEL.LONG.Housenumber' )
							}
						)
					);

					this.m_ObjectOwner.push(
						new ui.Form.TextInput(
							'',
							{
								name: 'object.owner.address.postalcode',
								required: true,
								placeholder: app.getMessage( 'Address.LABEL.SHORT.Postalcode' )
							}
						)
					);

					this.m_ObjectOwner.push(
						new ui.Form.TextInput(
							'',
							{
								name: 'object.owner.address.city',
								required: true,
								placeholder: app.getMessage( 'Address.LABEL.LONG.City' )
							}
						)
					);

					this.m_ObjectOwner.push(
						new ui.Form.TextInput(
							'',
							{
								name: 'object.owner.address.state',
								required: false,
								placeholder: app.getMessage( 'Address.LABEL.LONG.State' )
							}
						)
					);

					this.m_ObjectOwner.push(
						new ui.Form.TextInput(
							'',
							{
								name: 'object.owner.address.country',
								required: false,
								placeholder: app.getMessage( 'Address.LABEL.LONG.Country' )
							}
						)
					);

					this.m_ObjectOwner.push(
						new ui.Form.Select(
							{
								blank: app.getMessage( 'Realtor.NEW.TITLE.SELECT.gender' ),
								option:
								{
									m: app.getMessage( 'Realtor.NEW.TITLE.GENDER.MALE.select' ),
									f: app.getMessage( 'Realtor.NEW.TITLE.GENDER.FEMALE.select' )
								},
								name: 'object.owner.person.gender',
								required: true
							}
						)
					);

					this.m_ObjectOwner.push(
						new ui.Form.Select(
							{
								option:
								{
									'': '',
									'Dr.': app.getMessage( 'Realtor.NEW.TITLE.SALUTATION.SELECT.dr' ),
									'Prof.': app.getMessage( 'Realtor.NEW.TITLE.SALUTATION.SELECT.prof' ),
									'Prof. Dr.': app.getMessage( 'Realtor.NEW.TITLE.SALUTATION.SELECT.profdr' )
								},
								name: 'object.owner.person.salutation'
							}
						)
					);

					this.m_ObjectOwner.push(
						new ui.Form.TextInput(
							'',
							{
								name: 'object.owner.person.name',
								placeholder: app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.LABEL.name' ),
								required: true
							}
						)
					);

					this.m_ObjectOwner.push(
						new ui.Form.TextInput(
							'',
							{
								name: 'object.owner.person.surname',
								placeholder: app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.LABEL.surname' ),
								required: true
							}
						)
					);

					this.m_ObjectOwner.push(
						new ui.Form.DateInput(
							new Date(),
							'd.m.Y',
							{
								name: 'object.owner.person.birthday',
								required: true
							}
						)
					);
				}

				const addObjectInput	= ( input: ui.Form.BasicInputField, baseclass: string[] = [] ) => { this.m_Form.Input( input ); input.Base().addClass( baseclass.join( ' ' ) ); };

				{ // Objektadresse
					this.m_ObjectData.append( ui.$$.h( 4, app.getMessage( 'Address.TYPE.LONG.PostalAddress' ) ) );

					let fg							= ui.$$.div().addClass( 'form-group' ).appendTo( this.m_ObjectData.Root() );
					ui.$$.label().addClass( 'control-label col-xs-12 col-md-2' ).text( app.getMessage( 'Address.LABEL.COMB.Str_HNo' ) + '*' ).appendTo( fg );
					addObjectInput( this.m_ObjectAddress[ 0 ].rebuild( fg ), [ 'col-xs-12', 'col-md-7' ] );
					addObjectInput( this.m_ObjectAddress[ 1 ].rebuild( fg ), [ 'col-xs-12', 'col-md-3' ] );

					fg									= ui.$$.div().addClass( 'form-group' ).appendTo( this.m_ObjectData.Root() );
					ui.$$.label().addClass( 'control-label col-xs-12 col-md-2' ).text( app.getMessage( 'Address.LABEL.COMB.PC_City' ) + '*' ).appendTo( fg );
					addObjectInput( this.m_ObjectAddress[ 2 ].rebuild( fg ), [ 'col-xs-12', 'col-md-3' ] );
					addObjectInput( this.m_ObjectAddress[ 3 ].rebuild( fg ), [ 'col-xs-12', 'col-md-7' ] );

					fg									= ui.$$.div().addClass( 'form-group' ).appendTo( this.m_ObjectData.Root() );
					ui.$$.label().addClass( 'control-label col-xs-12 col-md-2' ).text( app.getMessage( 'Address.LABEL.COMB.State_Country' ) ).appendTo( fg );
					addObjectInput( this.m_ObjectAddress[ 4 ].rebuild( fg ), [ 'col-xs-12', 'col-md-5' ] );
					addObjectInput( this.m_ObjectAddress[ 5 ].rebuild( fg ), [ 'col-xs-12', 'col-md-5' ] );

					this.m_ObjectData.append( ui.$$.hr() );
				}

				{ // Objektdaten
					this.m_ObjectData.append( ui.$$.h( 4, app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.OBJECT.title' ) ) );

					let fg	= ui.$$.div().addClass( 'form-group' ).appendTo( this.m_ObjectData.Root() );
					ui.$$.label().addClass( 'control-label col-xs-12 col-md-2' ).text( app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.OBJECT.kind' ) + '*' ).appendTo( fg );
					addObjectInput( this.m_ObjectDatas[ 0 ].rebuild( fg ), [ 'col-xs-12', 'col-md-10' ] );

					fg			= ui.$$.div().addClass( 'form-group' ).appendTo( this.m_ObjectData.Root() );
					ui.$$.label().addClass( 'control-label col-xs-5 col-md-2' ).text( app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.OBJECT.buildyear' ) + '*' ).appendTo( fg );
					addObjectInput( this.m_ObjectDatas[ 2 ].rebuild( fg ), [ 'col-xs-4', 'col-md-4' ] );

					addObjectInput( this.m_ObjectDatas[ 1 ].rebuild( fg ), [ 'col-xs-3', 'col-md-5 col-md-offset-1' ] );

					fg			= ui.$$.div().addClass( 'form-group' ).appendTo( this.m_ObjectData.Root() );
					ui.$$.label().addClass( 'control-label col-xs-12 col-md-2' ).text( app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.OBJECT.constructionrate' ) + '*' ).appendTo( fg );
					addObjectInput( this.m_ObjectDatas[ 3 ].rebuild( fg ), [ 'col-xs-12', 'col-md-10' ] );

					fg			= ui.$$.div().addClass( 'form-group' ).appendTo( this.m_ObjectData.Root() );
					ui.$$.label().addClass( 'control-label col-xs-12 col-md-2' ).text( app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.OBJECT.usage' ) ).appendTo( fg );
					addObjectInput( this.m_ObjectDatas[ 4 ].rebuild( fg ), [ 'col-xs-12', 'col-md-10' ] );

					fg			= ui.$$.div().addClass( 'form-group' ).appendTo( this.m_ObjectData.Root() );
					ui.$$.label().addClass( 'control-label col-xs-12 col-md-2' ).text( app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.OBJECT.tenancyrate' ) + '*' ).appendTo( fg );
					addObjectInput( this.m_ObjectDatas[ 5 ].rebuild( fg ), [ 'col-xs-12', 'col-md-10' ] );

					fg			= ui.$$.div().addClass( 'form-group' ).appendTo( this.m_ObjectData.Root() );
					ui.$$.label().addClass( 'control-label col-xs-12 col-md-2' ).text( app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.OBJECT.remark' ) ).appendTo( fg );
					addObjectInput( this.m_ObjectDatas[ 6 ].rebuild( fg ), [ 'col-xs-12', 'col-md-10' ] );

					this.m_ObjectData.append( ui.$$.hr() );
				}

				{ // Eigentümer
					this.m_ObjectData.append(
						$(
							new Button
							(
								{
									title: app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.copy_from_customer' ),
									style: 'info',
									size: 'sm',
									classes: [ 'pull-right' ],
									on:
									{
										click: () =>
										{
											const findInputByName = ( name: string ): ui.Form.BasicInputField|undefined =>
											{
												return this.m_CustomerInputs.find(
													( input: ui.Form.BasicInputField ): boolean =>
													{
														if ( !input ) { return false; }

														return input.Name === name;
													}
												);
											};

											this.m_ObjectOwner.forEach(
												(input) =>
												{
													if ( !input.Name ) { return; }

													const prefill = findInputByName(
														input.Name.replace( 'object.owner.address', 'customer.address' ).replace( 'object.owner.person', 'customer.client' )
													);

													if ( prefill ) { input.value( prefill.val() ); }
												}
											);
										}
									}
								}
							).getElement()
						)
					);
					this.m_ObjectData.append( ui.$$.h( 4, app.getMessage( 'Realtor.NEW.TITLE.object-owner' ) ) );
					this.m_ObjectData.append( ui.$$.h( 4, app.getMessage( 'Realtor.NEW.TITLE.object-person-data' ) ).addClass( 'text-muted' ) );

					let fg							= ui.$$.div().addClass( 'form-group' ).appendTo( this.m_ObjectData.Root() );
					ui.$$.label().addClass( 'control-label col-xs-12 col-md-2' ).text( app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.LABEL.gender' ) + '*' ).appendTo( fg );
					addObjectInput( this.m_ObjectOwner[ 6 ].rebuild( fg ), [ 'col-xs-12', 'col-md-4' ] );
					ui.$$.label().addClass( 'control-label col-xs-12 col-md-2' ).text( app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.LABEL.salutation' ) ).appendTo( fg );
					addObjectInput( this.m_ObjectOwner[ 7 ].rebuild( fg ), [ 'col-xs-12', 'col-md-4' ] );

					fg									= ui.$$.div().addClass( 'form-group' ).appendTo( this.m_ObjectData.Root() );
					ui.$$.label().addClass( 'control-label col-xs-12 col-md-2' ).text( app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.LABEL.name' ) + '*' ).appendTo( fg );
					addObjectInput( this.m_ObjectOwner[ 8 ].rebuild( fg ), [ 'col-xs-12', 'col-md-10' ] );

					fg									= ui.$$.div().addClass( 'form-group' ).appendTo( this.m_ObjectData.Root() );
					ui.$$.label().addClass( 'control-label col-xs-12 col-md-2' ).text( app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.LABEL.surname' ) + '*' ).appendTo( fg );
					addObjectInput( this.m_ObjectOwner[ 9 ].rebuild( fg ), [ 'col-xs-12', 'col-md-10' ] );

					fg									= ui.$$.div().addClass( 'form-group' ).appendTo( this.m_ObjectData.Root() );
					ui.$$.label().addClass( 'control-label col-xs-12 col-md-2' ).text( app.getMessage( 'Aux.BASIC.OBJECT.REALTOR.NEW.LABEL.birthday' ) ).appendTo( fg );
					addObjectInput( this.m_ObjectOwner[ 10 ].rebuild( fg ), [ 'col-xs-12', 'col-md-10' ] );

					this.m_ObjectData.append( ui.$$.h( 4, app.getMessage( 'Address.SPECIAL.PostalAddress_Administrative' ) ).addClass( 'text-muted' ) );
					fg									= ui.$$.div().addClass( 'form-group' ).appendTo( this.m_ObjectData.Root() );
					ui.$$.label().addClass( 'control-label col-xs-12 col-md-2' ).text( app.getMessage( 'Address.LABEL.COMB.Str_HNo' ) + '*' ).appendTo( fg );
					addObjectInput( this.m_ObjectOwner[ 0 ].rebuild( fg ), [ 'col-xs-12', 'col-md-7' ] );
					addObjectInput( this.m_ObjectOwner[ 1 ].rebuild( fg ), [ 'col-xs-12', 'col-md-3' ] );

					fg									= ui.$$.div().addClass( 'form-group' ).appendTo( this.m_ObjectData.Root() );
					ui.$$.label().addClass( 'control-label col-xs-12 col-md-2' ).text( app.getMessage( 'Address.LABEL.COMB.PC_City' ) + '*' ).appendTo( fg );
					addObjectInput( this.m_ObjectOwner[ 2 ].rebuild( fg ), [ 'col-xs-12', 'col-md-3' ] );
					addObjectInput( this.m_ObjectOwner[ 3 ].rebuild( fg ), [ 'col-xs-12', 'col-md-7' ] );

					fg									= ui.$$.div().addClass( 'form-group' ).appendTo( this.m_ObjectData.Root() );
					ui.$$.label().addClass( 'control-label col-xs-12 col-md-2' ).text( app.getMessage( 'Address.LABEL.COMB.State_Country' ) ).appendTo( fg );
					addObjectInput( this.m_ObjectOwner[ 4 ].rebuild( fg ), [ 'col-xs-12', 'col-md-5' ] );
					addObjectInput( this.m_ObjectOwner[ 5 ].rebuild( fg ), [ 'col-xs-12', 'col-md-5' ] );
				}
			}

			private build()
			{
				this.m_ObjectData.empty();
				this.m_CustomerData.empty();
				this.m_ObjectData.rebuild();
				this.m_CustomerData.rebuild();

				while ( this.m_CustomerInputs.length > 0 )
				{
					const input = this.m_CustomerInputs.pop();

					if ( !input ) { continue; }

					this.m_Form.removeInput( input );

					input.remove();
				}

				const fg = ui.$$.div().addClass( 'form-group formless' ).appendTo( this.m_CustomerData.Root() );

				fg.append(
					ui.$$.p().addClass( 'form-required text-danger small-caps' ).text(
						app.getMessage( 'Aux.REQUIRED_INPUTS' )
					)
				);

				this.m_CustomerType.rebuild( fg );

				fg.append(
					ui.$$.p().text(
						app.getMessage( 'Realtor.NEW.TITLE.CUSTOMER-TYPE.HELP-BLOCK' ) + '*'
					).addClass( 'help-block' )
				);

				this.m_CustomerData.append( ui.$$.hr() );

				const radio = this.m_CustomerType.val() as string;

				if ( radio === 'NEW' )
				{
					this.buildNewCustomerForm();
				}
				else if ( radio === 'OLD' )
				{
					this.buildOldCustomerForm();
				}

				this.buildObjectForm();
			}

		}

	}
}
